import _ from "lodash";
import React, { useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import styled from "styled-components";

import { DraggableBlock } from "./DraggableBlock";

const INIT_DATA = [
  { name: "BLOCK 1", type: "A" },
  { name: "BLOCK 2", type: "A" },
];

const IMPORT_BLOCK_LIST = [{ type: "A" }, { type: "B" }, { type: "C" }];

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 550px;
  background: white;
  overflow-x: scroll;
`;

export default () => {
  const [blockList, setBlockList] = useState(INIT_DATA);

  const moveBlock = (fromIndex, toIndex) => {
    const updatedList = [...blockList];
    const [movedItem] = updatedList.splice(fromIndex, 1);
    updatedList.splice(toIndex, 0, movedItem);
    setBlockList(updatedList);
  };

  const onHandleImportBlock = ({ type }) => {
    const currentSize = _.size(blockList);
    const blockName = `BLOCK ${currentSize + 1}`;
    const newBlock = { name: blockName, type };
    setBlockList([...blockList, newBlock]);
  };

  return (
    <div>
      {_.map(IMPORT_BLOCK_LIST, (item, index) => (
        <button
          key={index} // ต้องมี key เพื่อป้องกัน warning ของ React
          style={{ padding: 40, background: "white", color: "red" }}
          onClick={() => onHandleImportBlock({ type: item.type })}
        >
          {item.type}
        </button>
      ))}
      <DndProvider backend={HTML5Backend}>
        <BlockContainer>
          {_.map(blockList, (item, index) => (
            <DraggableBlock
              key={index}
              index={index}
              item={item}
              moveBlock={moveBlock}
            />
          ))}
        </BlockContainer>
      </DndProvider>
    </div>
  );
};
